// extracted by mini-css-extract-plugin
export default {"textArea":"styles_textArea__NgPZl"};